import type { Page } from "@/types/content";

export const pages: Page[] = [
  {
    id: "page-1",
    slug: "about",
    title: "關於美好時光指南",
    content: [
      {
        _type: "hero",
        _key: "about-hero",
        title: "關於美好時光指南",
        subtitle: "活動界的米其林指南",
        backgroundImage: "https://public.readdy.ai/ai/img_res/edited_be1318f35a618a66b41a3cd52f839ae3_175e98dc.jpg",
      },
      {
        _type: "richText",
        _key: "about-intro",
        content: "<p>美好時光指南誕生於一個簡單的信念：每個人都值得擁有精彩的生活體驗。</p><p>我們派出的神秘客，實際體驗每間店家、每場活動，用真實的評比幫你篩選出最值得推薦的選擇。</p>",
      },
      {
        _type: "featureList",
        _key: "about-features",
        title: "我們的特色",
        features: [
          { _key: "af1", icon: "ri-spy-line", title: "神秘客實測", description: "每位神秘客都匿名體驗，確保評比公正客觀" },
          { _key: "af2", icon: "ri-bar-chart-grouped-line", title: "完整評比維度", description: "從環境、服務、CP 值多面向評分" },
          { _key: "af3", icon: "ri-booklet-line", title: "懶人包整理", description: "複雜資訊一次幫你整理好，決定不猶豫" },
        ],
      },
      {
        _type: "cta",
        _key: "about-cta",
        title: "成為神秘客",
        subtitle: "加入我們的體驗評比團隊",
        buttonLabel: "立即加入",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "關於美好時光指南｜活動界的米其林指南",
      description: "美好時光指南透過神秘客實測，為你評比全台灣最棒的活動與店家體驗。",
    },
  },
];